// Repasse = transferência empresa <-> fornecedor, de 2 tipos (single-asset):
//   - envio       (pagamento): empresa OUT + fornecedor OUT  -> tabela payments
//   - recebimento:             empresa IN  + fornecedor IN   -> supplier-receipts

export type RepasseCategory = "envio" | "recebimento";

export interface IRepasse {
  id: string | number;
  category: RepasseCategory;
  supplier?: { id: number; name: string } | null;
  asset?: { id: number; name: string; symbol: string } | null;
  value: string;
  status: string;
  date: string; // createdAt (já formatado pelo Api)
}

export interface RepasseForm {
  category: RepasseCategory;
  supplier_id: number | "";
  asset_id: number | "";
  value: string;
  date: Date | null;
}

export const INITIAL_REPASSE_FORM: RepasseForm = {
  category: "envio",
  supplier_id: "",
  asset_id: "",
  value: "",
  date: null,
};

export interface RepasseFilters {
  supplier_id: number | "";
  asset_id: number | "";
  status: string;
  category: RepasseCategory | "";
  start: Date | null;
  end: Date | null;
}

export const INITIAL_REPASSE_FILTERS: RepasseFilters = {
  supplier_id: "",
  asset_id: "",
  status: "",
  category: "",
  start: null,
  end: null,
};
